import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";

const Banner = () => {
  const navigate = useNavigate();

  const [tabs, setTabs] = useState(1);

  return (
    <div>
      <Topbar header={"Banner"} />
      <div className="d-flex  flex-wrap gap-3">
        <div
          onClick={() => {
            setTabs(1);
            navigate("/home-banners", { state: { type: "add" } });
          }}
          className={`${tabs == 1 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Home Banner
        </div>
        <div
          onClick={() => {
            setTabs(2);
            navigate("/property-banners", { state: { type: "add" } });
          }}
          className={`${tabs == 2 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Property Banner
        </div>
        <div
          onClick={() => {
            setTabs(3);
            navigate("/refer-and-earn", { state: { type: "add" } });
          }}
          className={`${tabs == 3 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Refer & Earn Banner
        </div>
        <div
          onClick={() => {
            setTabs(4);
            navigate("/booking-details", { state: { type: "add" } });
          }}
          className={`${tabs == 4 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Booking Detail Banner
        </div>
        <div
          onClick={() => {
            setTabs(5);
            navigate("/wallet-banner", { state: { type: "add" } });
          }}
          className={`${tabs == 5 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Wallet Banner
        </div>
        <div
          onClick={() => {
            setTabs(6);
            navigate("/day-outing", { state: { type: "add" } });
          }}
          className={`${tabs == 6 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Day Outing Free Ticket Banner
        </div>
        <div
          onClick={() => {
            setTabs(7);
            navigate("/owner-banner", { state: { type: "add" } });
          }}
          className={`${tabs == 7 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Owner Banner
        </div>
        <div
          onClick={() => {
            setTabs(8);
            navigate("/booking-banner", { state: { type: "add" } });
          }}
          className={`${tabs == 8 ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          Booking history banner
        </div>
      </div>
    </div>
  );
};
export default Banner;
